import { Button } from '@/common/ui/button'
import { Calendar } from '@/common/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/common/ui/popover'
import { CalendarIcon } from '@radix-ui/react-icons'
import { format } from 'date-fns'
import * as React from 'react'
import { useDate } from '@/common/hooks/useDate'

interface DatePickerProps {
	placeholder?: string
}

export function DatePicker({ placeholder = 'เลือกวันที่' }: DatePickerProps) {
	const { date, setDate } = useDate()
	const [open, setOpen] = React.useState(false)

	// Memoize selectedDate to prevent unnecessary recalculations
	const selectedDate = React.useMemo(() => {
		return date ? new Date(date + 'T00:00:00') : undefined
	}, [date])

	const [tempDate, setTempDate] = React.useState<Date | undefined>(selectedDate)

	// Update tempDate when selectedDate changes (but not when popover is open)
	React.useEffect(() => {
		if (!open && selectedDate) {
			setTempDate(selectedDate)
		}
	}, [date, open]) // Use date instead of selectedDate to avoid object reference issues

	const handleSelect = (newDate: Date | undefined) => {
		setTempDate(newDate)
	}

	const handleConfirm = () => {
		if (tempDate) {
			const formattedDate = format(tempDate, 'yyyy-MM-dd')
			setDate(formattedDate)
		}
		setOpen(false)
	}

	return (
		<div className="flex items-center space-x-2">
			<Popover open={open} onOpenChange={setOpen}>
				<PopoverTrigger asChild>
					<Button>
						<CalendarIcon className="mr-2" />
						<span>
							{selectedDate ? format(selectedDate, 'yyyy-MM-dd') : placeholder}
						</span>
					</Button>
				</PopoverTrigger>
				<PopoverContent className="p-4">
					<Calendar
						mode="single"
						selected={tempDate}
						onSelect={handleSelect}
						defaultMonth={selectedDate}
					/>
					<div className="mt-4 flex justify-end">
						<Button onClick={handleConfirm} disabled={!tempDate}>
							ยืนยัน
						</Button>
					</div>
				</PopoverContent>
			</Popover>
		</div>
	)
}
